import React, { useState } from 'react'
import { useTranslation } from "react-i18next";
import { Card, Row, Col } from "react-bootstrap"
import CLabel from '../../../../Common/CLabel';
import Message from '../../../../Common/Message';
import ToolBar from '../../../../../components/Common/Toolbar';
import { useGetMessageById, useOfGetCompactViewMode } from '../../../../../hooks/services/sBook/useOfMessage';
import { useGetDocumentListByMessageFromMessageBox } from '../../../../../hooks/services/sBook/useOfDocument';
import List from '../../../../Templates/List';
import SidePanelResponse from '../../V2/MessageBox/SidePanelResponse'
import { Icon, SpinnerSize, Toggle, TooltipHost } from '@fluentui/react';
import { ActionButton, IconButton, PrimaryButton } from '@fluentui/react/lib/Button';
import SidePanelNewCommentEvent from '../../V2/MessageBox/SidePanelNewCommentEvent';
import SidePanelViewMessage from '../../V2/MessageBox/SidePanelViewMessage';
import moment from "moment-timezone"
import { Pivot, PivotItem } from '@fluentui/react';
import CTextAreaSimple from '../../../../Common/CTextAreaSimple';
import SidePanelEdit from './SidePanelEdit';
import QRCode from "react-qr-code";
import NoDataLayer from "../../../../Common/NoDataLayer";
import { getAddSignature, sendAlertMessage } from '../../../../../services/sBook/message.service';
import { TooltipOverflowMode } from '@fluentui/react/lib/Tooltip';
import { mergeStyleSets } from '@fluentui/react/lib/Styling';
import { css } from '@fluentui/react/lib/Utilities';
import { __DocumentTypeKeys, enum__MessageStatus } from '../../../../../common/Dictionaries';
import { base64ToArrayBuffer, convertToLocalClientTimeZone, convettSignatureDatesToGMTLocal, getKeyByValue, isBookApproverOrCreator, isNullUndefined, saveByteArray, setGlobalCompactViewMode, visibilityButtonSignMessage } from '../../../../../common/Helpers';
import { downloadDocumentsByIds } from '../../../../../services/sBook/document.service';
import ListPagination from '../../../../Templates/List/ListPagination';
import MessageIconStatus from '../../MessageIconStatus';
import SendAlertDialog from '../../MessageBox/SendAlertDialog';
import { __onRenderOverflowButton, __onRenderOverflowItem } from '../../../../../common/CommonFuctions';
import { CustomCommandBarButton } from '../../../../../common/ObjectStructures/Trasnversal';
import { useSelector } from 'react-redux';
import { ExportBookOrMessageToPdf } from '../../../../../common/FileManager/ExportFunction';
import MessageDistributionGroupStatus from './SubComponents/MessageDistributionGroupStatus';
import DestinationParties from './SubComponents/DestinationParties';
import Loading from '../../../../Templates/Site/Loading';

function MessageBox(props) {
    const { t } = useTranslation();
    const { token: currentAuth } = useSelector((state) => state.auth);

    //Parametros de entrada.s
    const inputParam_BookObject = props.bookObject !== null && props.bookObject !== undefined ? props.bookObject : null;
    const inputParam_MessageObjectId = props.messageObjectId !== null && props.messageObjectId !== undefined ? props.messageObjectId : null;
    const inputParam_MessageObjectSectionId = props.messageObjectSectionId !== null && props.messageObjectSectionId !== undefined ? props.messageObjectSectionId : null;
    const inputParam_MessageObjectStatusId = props.messageObjectStatusId !== null && props.messageObjectStatusId !== undefined ? props.messageObjectStatusId : null;
    
    const inputParam_UserProps = props.userProps !== null && props.userProps !== undefined ? props.userProps : null;
    const inputParam_SetFireUpdateBoxListMessageEventControl = props.setterFireUpdateBoxListControl !== null && props.setterFireUpdateBoxListControl !== undefined ? props.setterFireUpdateBoxListControl : null;
    const inputParam_EditMode = props.editMode === null? null : props.editMode !== undefined ? props.editMode : false;
    const inputParam_CurrentUserName = props.currentUserName !== null && props.currentUserName !== undefined ? props.currentUserName : null;
    const inputParam_SetterObjMessageList = props.setterObjMessageList !== null && props.setterObjMessageList !== undefined ? props.setterObjMessageList : null;

    const inputParam_FireGetMessage = props.fireGetMessage !== null && props.fireGetMessage !== undefined ? props.fireGetMessage : false;
    const inputParam_SetFireGetMessage = props.setFireGetMessage !== null && props.setFireGetMessage !== undefined ? props.setFireGetMessage : null;
    const inputParam_MessageCounts = props.messageCounts !== null && props.messageCounts !== undefined ? props.messageCounts : null;

    const inputParam_DataFilled = props.dataFilled !== null && props.dataFilled !== undefined ? props.dataFilled : null;
    const inputParam_SetDataFilled = props.setDataFilled !== null && props.setDataFilled !== undefined ? props.setDataFilled : null;

    //Parametros de componente.
    const [successful, setSuccessful] = useState(null);
    const [message, setMessage] = useState(null);
    const [messageType, setMessageType] = useState(null);
    const [showMessage, setShowMessage] = useState(false);

    const [tglCompactView, setTglCompactView] = useState(null);
    useOfGetCompactViewMode("messageBox", tglCompactView, setTglCompactView, true)

    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [isPanelResponseOpen, setIsPanelResponseOpen] = useState(false);
    const [isPanelEditOpen, setIsPanelEditOpen] = useState(false);
    const [isPanelViewMessageOpen, setIsPanelViewMessageOpen] = useState(false);
    const [loadFired, setLoadFired] = useState(false);
    
    const [isPanelNewCommentOpen, setIsPanelNewCommentOpen] = useState(false);
    const [selectedPivotKey, setSelectedPivotKey] = useState("0");
    
    const [documentList, setDocumentList] = useState({fireUpdate: true, data: null, pageNumber: 1, pageSize: 5, filters: []});
    useGetDocumentListByMessageFromMessageBox(inputParam_MessageObjectId, setDocumentList, inputParam_DataFilled, inputParam_SetDataFilled);

    const [objMessage, setObjMessage] = useState({
        id: null,
        messageNemo: null,//Not null
        messageCode: null,//Not null
        correlative: null,
        title: null,
        body: null,
        topicId: null,
        messageTopicCode: null,
        senderUsername: null,//Not null
        sectionPartySenderId: null,//Not null
        sendDate: null,
        answerNeeded: null,
        answerToMessage: null,
        answerMessageNemo: null,
        answerMessageId: null,
        answerDeadlineDate: null,
        attacheds: false,
        statusId: null,
        visa: null,
        //Propiedades que no tiene el objeto mensaje en los paneles laterales.
        signatureQR: null,
        statusName: null,
        sendedPartyName: null,
        sendedPartyId: null,
        sectionName: null,
        answerMessageCode: null,
        hasSignature: false,
        sectionId: null,
        deactivate: false,
        l_partys_to: []
    });

    //[##SectionPartyMember Get Message Corrección 09-08-2024##]
    useGetMessageById(
        inputParam_MessageObjectId,
        inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === inputParam_MessageObjectSectionId) === undefined ?
            (inputParam_UserProps.isAdmin ? 0 : "#NA#")
            :
            inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === inputParam_MessageObjectSectionId).sectionPartyMemberId,
        setObjMessage,
        inputParam_FireGetMessage,
        inputParam_SetFireGetMessage,
        setLoadFired
    )
       
    //Funciones de componente.

    //Eventos de componente.
    const setFireUpdateBoxListMessageEventControl = () => {
        inputParam_SetFireUpdateBoxListMessageEventControl(true);
    }

    const onResponseMessage = () => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelResponseOpen(true);
        } else {
            alert("Debe crear el libro primero.");
        }
    };

    const onEditMessage = () => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelEditOpen(true);
        } else {
            alert("Debe crear el libro primero.");
        }
    };

    const onAddCommentEvent = () => {
        if (inputParam_BookObject.id !== 0) {
            setIsPanelNewCommentOpen(true);
        } else {
            alert("Debe crear el libro primero.");
        }
    };

    const onSendRetryMessageAlert = () => {
        sendAlertMessage(inputParam_BookObject.id, objMessage.sectionId,  objMessage.id).then((response) => { 
            if (response.data.succeeded) {
                setShowMessage(true)
                setSuccessful(true)
                setMessageType("success");
                setMessage(t('data-lang-msg-operationperformed')) 
            } else {
                setShowMessage(true)
                setSuccessful(true)
                setMessageType("error");
                setMessage(t('data-lang-msg-operationerror'))
            } 
            
            setIsDialogOpen(true);
        }).catch(() => {
            setShowMessage(true)
            setSuccessful(true)
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    };

    const onAddSignMessage = () => {
        const objSignature = {
            id: 0,
            messageId: objMessage.id,
            sectionPartyMemberId: inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === objMessage.sectionId).sectionPartyMemberId,
            messageDocumentId: null,
            messageSignQr: "",
            messageSignDate: moment(Date.now()).format("YYYY-MM-DDTHH:mm:ss.SSSZ")
        }

        getAddSignature(objSignature).then((response) => {
            objMessage.signatureQR = response.data.data;
            objMessage.hasSignature = true;
            setObjMessage(objMessage)

            setShowMessage(true)
            setSuccessful(true);
            setMessageType("success");
            setMessage(t('data-lang-msg-operationperformed'))
        }).catch(() => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    };
    
    const onDownloadDocumentsByIds = (documentList, fileName) => {
        downloadDocumentsByIds(documentList).then((response) => {
            saveByteArray(fileName, base64ToArrayBuffer(response.data.data));
        }).catch(() => {
            setShowMessage(true)
            setSuccessful(false);
            setMessageType("error");
            setMessage(t('data-lang-msg-operationerror'))
        });
    }

    const onSelectPivotKey = (item, ev) => {
        try {
            const pivotKey = item.key.replace(".", "");

            if (pivotKey === '2') {
                setDocumentList(prevState => ({
                    ...prevState,
                    fireUpdate:true
                }))
            }

            setSelectedPivotKey(pivotKey)
        } catch (error) {
            
        }
    }

    const onViewAnsweredMessage = (answerMessageId) => {
        setIsPanelViewMessageOpen(true);
    };

    const handleExportMessagePdf = async () => {  
        await ExportBookOrMessageToPdf(t, inputParam_BookObject,inputParam_UserProps.partyMemberId, objMessage.id, objMessage.messageCode, currentAuth.token.clientName, false, currentAuth.token.userName)
    };

    const onCompactViewChange = (e, checked) => {
        setGlobalCompactViewMode("messageBox", checked)
        setTglCompactView(checked);
    };

    let userSectionPartyIdMatchWithMessage = inputParam_UserProps.username !== null && objMessage.id !== null ?
        (inputParam_UserProps.isAdmin ? 0 : 
            inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (objMessage.sectionId !== null ? objMessage.sectionId : null)) !== undefined ? inputParam_UserProps.l_SectionPartyMemberHandler.find(x => x.sectionId === (objMessage.sectionId !== null ? objMessage.sectionId : null)).sectionPartyId : 0) : null;

    //Constante resagada, esto dado que deben existir los eventos del comonente para poder ser invocados en array de toolbar.
    const toolBarItems_Communication  = [
        {
            key: 'reply',
            text: t('data-lang-btn-reply'),
            style: { display: (inputParam_UserProps.onlyObserver === false &&
                            //(inputParam_UserProps.username !== null && ((inputParam_UserProps.roleId === 1 || inputParam_UserProps.roleId === 2))) && 
                            isBookApproverOrCreator(inputParam_UserProps) && 
                            (userSectionPartyIdMatchWithMessage !== null && userSectionPartyIdMatchWithMessage !== undefined) &&
                            (objMessage && (objMessage.statusId === enum__MessageStatus.SENDED)) ? "unset" : "none") },
            display:  (inputParam_UserProps.onlyObserver === false &&
                        //(inputParam_UserProps.username !== null && ((inputParam_UserProps.roleId === 1 || inputParam_UserProps.roleId === 2))) && 
                        isBookApproverOrCreator(inputParam_UserProps) && 
                        (userSectionPartyIdMatchWithMessage !== null && userSectionPartyIdMatchWithMessage !== undefined) &&
                        (objMessage && (objMessage.statusId === enum__MessageStatus.SENDED)) ? true : false),
            iconProps: { iconName: 'MailReply' },
            onClick: onResponseMessage,
            commandBarButtonAs: CustomCommandBarButton
        },
        {
            key: 'edit',
            text: (!isNullUndefined(objMessage.visa) && objMessage.visa >= 0 && objMessage.statusId !== enum__MessageStatus.ONAPROBATION) ? ((objMessage.statusId === enum__MessageStatus.TOVISA && objMessage.visa === 2) ? t('data-lang-btn-edit') : t('data-lang-btn-view')) : t('data-lang-btn-edit'),
            style: { display: (
                            //(inputParam_UserProps.username !== null && (inputParam_UserProps.roleId === 1 || inputParam_UserProps.roleId === 2)) &&
                            isBookApproverOrCreator(inputParam_UserProps) && 
                            (userSectionPartyIdMatchWithMessage !== null && userSectionPartyIdMatchWithMessage !== undefined) &&
                            (objMessage && (objMessage.statusId === enum__MessageStatus.ONPRAPARATION || objMessage.statusId === enum__MessageStatus.ONCIRCULATION || objMessage.statusId === enum__MessageStatus.ONAPROBATION || objMessage.statusId === enum__MessageStatus.TOVISA))
                        ) ? "unset" : "none"
                    },
            iconProps: { iconName: (!isNullUndefined(objMessage.visa) && (objMessage.visa >= 0)) ? 'View' : 'EditMail' },
            onClick: onEditMessage,
            commandBarButtonAs: CustomCommandBarButton
        },
        {
            key: 'retrymessage',
            text: t('data-lang-btn-sendmessagealert'),
            style: { display: (
                    //(inputParam_UserProps.username !== null && (inputParam_UserProps.roleId === 1 || inputParam_UserProps.roleId === 2)) &&
                    isBookApproverOrCreator(inputParam_UserProps) && 
                    (userSectionPartyIdMatchWithMessage !== null && userSectionPartyIdMatchWithMessage !== undefined) &&
                    (objMessage && (objMessage.statusId === enum__MessageStatus.SENDED))
                ) ? "unset" : "none"
            },
            iconProps: { iconName: 'MailAlert' },
            onClick: onSendRetryMessageAlert,
        },
        {
            key: 'newcomment',
            text: t('data-lang-btn-newcomment'),
            style: { display: (
                //inputParam_UserProps.username !== null &&
                (inputParam_UserProps.l_SectionPartyMemberHandler.length > 0 ? true : inputParam_UserProps.isAdmin ) &&
                inputParam_MessageObjectSectionId !== null &&
                //((inputParam_UserProps.roleId === 1 || inputParam_UserProps.roleId === 2))) ? "unset" : "none" },
                isBookApproverOrCreator(inputParam_UserProps)) ? "unset" : "none" },
            iconProps: { iconName: 'CommentAdd' },
            onClick: onAddCommentEvent,
        },
    ];

    const classNames = mergeStyleSets({
        overflow: {
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
          width: 180,
        },
        parent: {
          selectors: { '> *:last-child': { marginTop: 10 } },
        },
    });


    const getMessageData = () => {
        return <Row className='p-3'>
                    <Col xl={12}>
                        {
                            objMessage.messageCode && objMessage.title &&
                            <div className='d-flex'>
                                <MessageIconStatus style={{paddingRight: "10px", position: "unset", fontSize: "20px"}} acceptSendedStatus={true} statusId={ objMessage.statusId } visa={objMessage.visa} />
                                <CLabel aditionalStyles={{paddingTop: "3px"}} labelValue={ `${objMessage.messageCode} | ${objMessage.title}` } />
                            </div>
                        }
                    </Col>
                    {
                        objMessage.answerToMessage &&
                        <Col xl={12}>
                            <CLabel
                                labelText={ t('data-lang-lbl-answermessage') }
                                labelValue={ objMessage.answerMessageCode }
                                linked={ true }
                                linkedIconProps={{ iconName: 'Comment' }}
                                linkedEventFire={ onViewAnsweredMessage }
                            />
                        </Col>
                    }
                    <Col xl={12}>
                        <CTextAreaSimple labelText={t('data-lang-lbl-body')} controlValue={objMessage.body} setterControlValue={null} isInvalirControl={false} editMode={false} />
                    </Col>
                </Row>
    }

    const getAditionalInfoDataFullView = () => {
        return <>
                    <Row className='p-3'>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-answerneeded') } labelValue={ objMessage.answerNeeded ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={7}>
                            <CLabel labelText={ t('data-lang-lbl-answerdeadlinedate') } labelValue={ !isNullUndefined(objMessage.answerDeadlineDate) ? moment(objMessage.answerDeadlineDate).format("DD/MM/YYYY") : t('data-lang-lbl-notapply') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-answertomessage') } labelValue={ objMessage.answerToMessage ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-endorse') } labelValue={ objMessage.visa ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                        </Col>
                        {
                            objMessage.answerToMessage &&
                            <Col xl={12}>
                                <CLabel
                                    labelText={ t('data-lang-lbl-answermessage') }
                                    labelValue={ objMessage.answerMessageCode }
                                    linked={ true }
                                    linkedIconProps={{ iconName: 'Comment' }}
                                    linkedEventFire={ onViewAnsweredMessage }
                                />
                            </Col>
                        }
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t(objMessage.statusName) } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-topic') } labelValue={ objMessage.topicName } />
                        </Col>
                    </Row>
                </>
    }

    const getAditionalInfoDataTabView = () => {
        return <>
                    <Row className='p-3'>
                        {
                            objMessage.answerToMessage &&
                            <Col xl={12}>
                                <CLabel
                                    labelText={ t('data-lang-lbl-answermessage') }
                                    labelValue={ objMessage.answerMessageCode }
                                    linked={ true }
                                    linkedIconProps={{ iconName: 'Comment' }}
                                    linkedEventFire={ onViewAnsweredMessage }
                                />
                            </Col>
                        }
                        <Col xl={12}>
                            <CLabel labelText={ t('data-lang-lbl-topic') } labelValue={ t(objMessage.messageTopicName) } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-answerneeded') } labelValue={ objMessage.answerNeeded ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={7}>
                            <CLabel labelText={ t('data-lang-lbl-answerdeadlinedate') } labelValue={ !isNullUndefined(objMessage.answerDeadlineDate) ? moment(objMessage.answerDeadlineDate).format("DD/MM/YYYY") : t('data-lang-lbl-notapply') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-answertomessage') } labelValue={ objMessage.answerToMessage ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={7}>
                            <CLabel labelText={ t('data-lang-lbl-endorse') } labelValue={ objMessage.visa ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={5}>
                            <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t(objMessage.statusName) } />
                        </Col>
                    </Row>
                </>
    }
    
    const getSenderData = () => {
        return  <>
                    <Row className='p-3'>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-section') } labelValue={ objMessage.sectionName } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-senderparty') } labelValue={ objMessage.sendedPartyName } />
                        </Col>

                        <Col xs={12} sm={6} md={6} lg={6} xl={6} title={objMessage.senderUsername}>
                            <CLabel labelText={ t('data-lang-lbl-sender') } labelValue={ objMessage.senderFullname } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ convertToLocalClientTimeZone(objMessage.sendDate) } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6} className='ms-auto'>
                            <CLabel labelText={ t('data-lang-lbl-senddate') } labelValue={ convertToLocalClientTimeZone(objMessage.sendEventDate) } />
                        </Col>
                    </Row>
                    {
                        objMessage &&
                        <DestinationParties objMessage={objMessage} />
                    }
                    {
                        objMessage && objMessage.visa !== null && objMessage.canSeeVisaSection &&
                        <MessageDistributionGroupStatus objMessage={objMessage} />
                    }
                </>
    }

    const getDocumentsData = () => {
        return  <Row className='pb-2'>
                    {
                        (documentList && documentList.data && inputParam_BookObject.id !== null && inputParam_MessageObjectId !== null) &&
                        <Card>
                            <Card.Body className="d-flex flex-column" style={{overflow: "auto", paddingTop: "0px"}}>
                                {
                                    documentList.data !== null && documentList.data.length > 0 &&
                                    <>
                                        <List
                                            manipulateLocalData={ true }
                                            className="no-compact-list big-header"
                                            listLocalStoragePageSizeVariableName="messageBoxDocumentsEdit"
                                            data={ (documentList !== null ? documentList : []) }
                                            setData={ setDocumentList }
                                            columns={ [
                                                {
                                                    key: "documentCode",
                                                    name: t('data-lang-lbl-info'),
                                                    fieldName: "documentCode",
                                                    minWidth: 350,
                                                    isResizable: true,
                                                    onRender:(item, row) => {
                                                        return  <div>
                                                                    <Row>
                                                                        <Col style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-code')} labelValue={ item.documentCode } /> </Col>
                                                                        <Col className='col-auto me-auto' style={{whiteSpace: "break-spaces"}}><CLabel labelText={t('data-lang-lbl-creationusername')} labelValue={ item.creationUsername } /> </Col>
                                                                    </Row>
                                                                    <Row className='cursor-pointer'>
                                                                        <Col className='cursor-pointer' style={{whiteSpace: "break-spaces"}}>
                                                                            <TooltipHost content={t('data-lang-btn-download')}>
                                                                                <ActionButton className='p-0' styles={{root:{fontSize: "12px"}}} onClick={() => onDownloadDocumentsByIds([item.id], item.name)}>
                                                                                    <CLabel className='cursor-pointer' labelText={t('data-lang-lbl-name')} labelValue={ item.name } /> 
                                                                                    <Icon iconName='CloudDownload' style={{paddingBottom: "10px", fontSize: "16px", fontFamily: "FabricMDL2Icons"}} />
                                                                                </ActionButton>
                                                                            </TooltipHost>
                                                                        </Col>
                                                                    </Row>
                                                                    <Row>
                                                                    </Row>
                                                                </div>
                                                    }
                                                },
                                                {  
                                                    key: 'id',
                                                    name: t('data-lang-lbl-actions'),
                                                    fieldName: 'id',
                                                    minWidth: 50,
                                                    maxWidth: 50,
                                                    onRender:(item, row) => {
                                                        return <div></div>
                                                    }
                                                }
                                            ] }
                                        />
                                        <div className="mt-auto">
                                            <ListPagination
                                                listLocalStoragePageSizeVariableName="messageBoxDocumentsEdit" 
                                                data={ (documentList !== null ? documentList : []) }
                                                setData={ setDocumentList } />
                                        </div>
                                    </>
                                }
                                {
                                    documentList.data === null || documentList.data.length === 0 &&
                                    <NoDataLayer cstyle={{minHeight: "100px"}} display={true} />
                                }
                            </Card.Body>
                        </Card>
                    }
                </Row>
    }

    const getSignatureDataTabView = () => {
        return <>
                    <Row className='pt-1'> 
                        <Col xs={12}>
                            <CLabel labelText={ t('data-lang-lbl-hassignature') } labelValue={ objMessage.hasSignature && objMessage.hasSignature ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } />
                        </Col>
                    </Row>
                    <Row style={{display: "none"}} className='pt-1'>
                        <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                            <CLabel labelText={ t('data-lang-lbl-user') } labelValue={ "" } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                            <CLabel labelText={ t('data-lang-lbl-date') } labelValue={ "" } />
                        </Col>
                    </Row>
                    <Row className='pt-1 pb-2'>
                        <Col lg={4} xl={6} xxl={4}>
                            <div className='d-flex'>
                                <CLabel labelText={ t('data-lang-lbl-signatureqr') } labelValue={ "" } />
                                <NoDataLayer display={ !objMessage.hasSignature } />
                            </div>
                            {
                                objMessage.id !== null && objMessage.hasSignature &&
                                <QRCode
                                    id="qr-gen"
                                    value={ convettSignatureDatesToGMTLocal(objMessage.signatureQR) }
                                    size={170}
                                    level={"H"}
                                    includemargin="true"
                                    className={!objMessage.hasSignature ? "d-none" : ""}
                                    
                                />
                            }
                        </Col>
                        {
                            objMessage.hasSignature &&
                            <Col lg={8} xl={6} xxl={8}>
                                <div className='pt-4'>
                                    {`${t('data-lang-lbl-message')} ${convettSignatureDatesToGMTLocal(objMessage.signatureQR)}`}
                                </div>
                            </Col>
                        }
                        
                    </Row>

                    {
                        inputParam_UserProps.username !== null && inputParam_BookObject &&
                        <div className={{
                            flex: '1 1 auto',
                            borderTop: `1px solid green`,
                            display: 'flex',
                            padding: '12px 12px 14px 24px',
                        }}>
                            <Col>
                            {
                                !visibilityButtonSignMessage(inputParam_BookObject.autoSignature, inputParam_BookObject.requiresApproval, inputParam_UserProps, objMessage.sendedPartyId, objMessage.statusId, objMessage.hasSignature) &&
                                <div className="text-end">
                                    <PrimaryButton onClick={ onAddSignMessage }>{ t('data-lang-btn-sigin') }</PrimaryButton>
                                </div>
                            }
                            </Col>
                        </div>
                    }
                </>
    }

    const getSignatureDataFullView = () => {
        return <>
                    <Row className='pt-1'> 
                        <Col xs={12}>
                            <CLabel labelText={ t('data-lang-lbl-hassignature') } labelValue={ objMessage.hasSignature && objMessage.hasSignature ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } />
                        </Col>
                    </Row>
                    <Row style={{display: "none"}} className='pt-1'>
                        <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                            <CLabel labelText={ t('data-lang-lbl-user') } labelValue={ "" } />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={4}>
                            <CLabel labelText={ t('data-lang-lbl-date') } labelValue={ "" } />
                        </Col>
                    </Row>
                    <Row className='pt-1 pb-2'>
                        <Col lg={4} xl={6} xxl={4}>
                            <div className='d-flex'>
                                <CLabel labelText={ t('data-lang-lbl-signatureqr') } labelValue={ "" } />
                                <NoDataLayer display={ !objMessage.hasSignature } />
                            </div>
                            {
                                objMessage.id !== null && objMessage.hasSignature &&
                                <QRCode
                                    id="qr-gen"
                                    value={ convettSignatureDatesToGMTLocal(objMessage.signatureQR) }
                                    size={170}
                                    level={"H"}
                                    includemargin="true"
                                    className={!objMessage.hasSignature ? "d-none" : ""}
                                    
                                />
                            }
                        </Col>
                        {
                            objMessage.hasSignature &&
                            <Col lg={8} xl={6} xxl={8}>
                                <div className='pt-4'>
                                    {`${t('data-lang-lbl-message')} ${convettSignatureDatesToGMTLocal(objMessage.signatureQR)}`}
                                </div>
                            </Col>
                        }
                        
                    </Row>

                    {
                        inputParam_UserProps.username !== null && inputParam_BookObject &&
                        <div className={{
                            flex: '1 1 auto',
                            borderTop: `1px solid green`,
                            display: 'flex',
                            padding: '12px 12px 14px 24px',
                        }}>
                            <Col>
                            {
                                !visibilityButtonSignMessage(inputParam_BookObject.autoSignature, inputParam_BookObject.requiresApproval, inputParam_UserProps, objMessage.sendedPartyId, objMessage.statusId, objMessage.hasSignature) &&
                                <div className="text-end">
                                    <PrimaryButton onClick={ onAddSignMessage }>{ t('data-lang-btn-sigin') }</PrimaryButton>
                                </div>
                            }
                            </Col>
                        </div>
                    }
                </>
    }
    //Render de componente.
    return (
        <>
            {
                inputParam_EditMode === true &&
                <Card className='h-100'>
                    <Card.Header className="card-header-compact">
                        <Card.Title className="d-flex justify-content-between">
                            <b>{t('data-lang-boxname-communication')}</b>
                            <IconButton
                                menuIconProps={{ iconName: 'MoreVertical' }}
                                role="button"
                                className="action-menu-list-toolbar"
                                aria-haspopup
                                styles={{ root: { float: 'left', height: 'inherit', padding: '10px' } }}
                                menuProps={{
                                    items: [
                                        {
                                            key: 'exportpdf',
                                            iconProps: { iconName: 'PDF' },
                                            text: t('data-lang-btn-exportpdf'),
                                            onClick: () => handleExportMessagePdf(),
                                        },
                                    ],
                                }}
                            />
                        </Card.Title>
                    </Card.Header>
                    <Card.Footer style={{padding: "0px", borderBottom: "1px solid rgba(0, 0, 0, 0.125)"}}>
                        <div className='book-toolbar d-flex float-end'>
                            {
                                inputParam_EditMode && inputParam_BookObject && inputParam_BookObject.statusId === 2 &&
                                <ToolBar items={ toolBarItems_Communication } display={ true } />
                            }
                            <Toggle
                                label=""
                                checked={ tglCompactView !== null ? tglCompactView : false }
                                onChange={ onCompactViewChange }
                                role="checkbox"
                                onText={ t('data-lang-lbl-fullview') }
                                offText={ t('data-lang-lbl-tabview') }
                                styles={ {root:{ paddingTop: "10px", float: "right", display: "flex"}, label: {marginRight : "5px"}} }
                            />
                        </div>
                    </Card.Footer>
                        {
                            inputParam_MessageCounts === 0 && 
                            <Card.Body className='overflow-auto card-body-no-padding h-100'>
                                <Row className="h-100">
                                    <Col className="d-flex align-items-center justify-content-center">
                                        <div>{t('data-lang-lbl-nomessages')}</div>
                                    </Col>
                                </Row>
                            </Card.Body>
                        }
                        {
                            (inputParam_MessageCounts === null || inputParam_MessageCounts > 0) && 
                            <Card.Body className='card-body-no-padding h-100' style={{paddingTop: "0px"}}>
                                <Row>

                                        <Col xl={12}>
                                            {
                                                tglCompactView &&
                                                <div>
                                                    <div style={{borderBottom: "1px solid #999"}}>
                                                        <h4>{ t('data-lang-lbl-message') }</h4>
                                                        { 
                                                            (loadFired || objMessage.id) && getMessageData()
                                                        }
                                                        { 
                                                            !loadFired && !objMessage.id &&
                                                            <Row className='my-3'>
                                                                <Col className="d-flex align-items-center justify-content-center">
                                                                    <Loading
                                                                        inputParam_ShowLoading={true}
                                                                        inputParam_ShowText={false}
                                                                        inputParam_Width={'35px'}
                                                                        inputParam_Height={'35px'}
                                                                        inputParam_Left={""}
                                                                        inputParam_Style={{marginTop: 0}}
                                                                        inputParam_ColClassName={"me-2"}
                                                                        inputParam_MarginLeft={"auto"}
                                                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                                                </Col>
                                                            </Row>
                                                        }
                                                    </div>
                                                    <div style={{borderBottom: "1px solid #999"}}>
                                                        <h4 className="pt-2">{ t('data-lang-lbl-documents') }</h4>
                                                        {
                                                            (documentList && documentList.data) &&
                                                            getDocumentsData()
                                                        }
                                                        { 
                                                            !(documentList && documentList.data) &&
                                                            <Row className='my-3'>
                                                                <Col className="d-flex align-items-center justify-content-center">
                                                                    <Loading
                                                                        inputParam_ShowLoading={true}
                                                                        inputParam_ShowText={false}
                                                                        inputParam_Width={'35px'}
                                                                        inputParam_Height={'35px'}
                                                                        inputParam_Left={""}
                                                                        inputParam_Style={{marginTop: 0}}
                                                                        inputParam_ColClassName={"me-2"}
                                                                        inputParam_MarginLeft={"auto"}
                                                                        inputParam_SpinnerSize={SpinnerSize.medium} />
                                                                </Col>
                                                            </Row>
                                                        }
                                                    </div>
                                                    {
                                                        (loadFired || objMessage.id) &&
                                                        <>
                                                            <div style={{borderBottom: "1px solid #999"}}>
                                                                <h4 className="pt-2">{ t('data-lang-lbl-aditionalinfo') }</h4>
                                                                { getAditionalInfoDataTabView() }
                                                            </div>
                                                            <div style={{borderBottom: "1px solid #999"}}>
                                                                <h4 className="pt-2">{ t('data-lang-lbl-sender') }</h4>
                                                                { getSenderData() }
                                                            </div>
                                                            <div style={{borderBottom: "1px solid #999"}}>
                                                                <h4 className="pt-2">{ t('data-lang-lbl-signature') }</h4>
                                                                { getSignatureDataFullView() }
                                                            </div>
                                                        </>
                                                    }
                                                </div>
                                            }
                                            {
                                                !tglCompactView &&
                                                <>
                                                    { 
                                                        (loadFired || objMessage.id) &&
                                                        <Pivot styles={{root: {whiteSpace: "normal !important"}}} onLinkClick={onSelectPivotKey} selectedKey={selectedPivotKey} defaultSelectedKey="0">
                                                            <PivotItem headerText={ t('data-lang-lbl-message') }>
                                                                { getMessageData() }
                                                            </PivotItem>
                                                            <PivotItem headerText={ t('data-lang-lbl-aditionalinfo') }>
                                                                { getAditionalInfoDataFullView() }
                                                                { getSenderData() }
                                                            </PivotItem>
                                                            {
                                                                (objMessage.attacheds || true) &&
                                                                <PivotItem headerText={ t('data-lang-lbl-documents') }>
                                                                    { getDocumentsData() }
                                                                </PivotItem>
                                                            }
                                                            <PivotItem headerText={ t('data-lang-lbl-signature') } >
                                                                { getSignatureDataTabView() }
                                                            </PivotItem>
                                                        </Pivot>
                                                    }
                                                    { 
                                                        loadFired === false && !objMessage.id &&
                                                        <Row className='my-3'>
                                                            <Col className="d-flex align-items-center justify-content-center">
                                                                <Loading
                                                                    inputParam_ShowLoading={true}
                                                                    inputParam_ShowText={false}
                                                                    inputParam_Width={'35px'}
                                                                    inputParam_Height={'35px'}
                                                                    inputParam_Left={""}
                                                                    inputParam_Style={{marginTop: 0}}
                                                                    inputParam_ColClassName={"me-2"}
                                                                    inputParam_MarginLeft={"auto"}
                                                                    inputParam_SpinnerSize={SpinnerSize.medium} />
                                                            </Col>
                                                        </Row>
                                                    }
                                                </>
                                            }
                                        </Col>

                                </Row>
                                {
                                    isPanelViewMessageOpen &&
                                    <SidePanelViewMessage
                                        bookObject={inputParam_BookObject}
                                        userProps={ inputParam_UserProps }
                                        messageId={ objMessage.answerMessageId }
                                        messageSectionId={ objMessage.sectionId }
                                        messageStatusId={objMessage.statusId}
                                        currentUserName={inputParam_CurrentUserName}
                                        isPanelOpen={ isPanelViewMessageOpen }
                                        setterIsPanelOpen={ setIsPanelViewMessageOpen } 
                                        setterObjMessageList={ inputParam_SetterObjMessageList }
                                        fireGetMessage={ inputParam_FireGetMessage }
                                        setFireGetMessage={ inputParam_SetFireGetMessage }
                                    />
                                }
                                {
                                    isPanelResponseOpen &&
                                    <SidePanelResponse
                                        setterObjMessageList={ inputParam_SetterObjMessageList }
                                        bookObject={inputParam_BookObject}
                                        messageObject={ objMessage }
                                        isPanelOpen={ isPanelResponseOpen }
                                        userProps={ inputParam_UserProps }
                                        //setterDocumentList={setDocumentList}
                                        setterIsPanelOpen={ setIsPanelResponseOpen } 
                                        currentUserName={ inputParam_CurrentUserName }
                                        setterObjMessage={setObjMessage}
                                        setFireGetMessage={inputParam_SetFireGetMessage}
                                    />
                                }
                                {
                                    inputParam_UserProps.username !== null && isPanelEditOpen &&
                                    <SidePanelEdit
                                        setterObjMessageList={ inputParam_SetterObjMessageList }
                                        bookObject={inputParam_BookObject}
                                        messageObject={ objMessage }
                                        isPanelOpen={ isPanelEditOpen }
                                        userProps={ inputParam_UserProps }
                                        setterDocumentList={setDocumentList}
                                        setterIsPanelOpen={ setIsPanelEditOpen } 
                                        setterObjMessage={setObjMessage}
                                        setFireGetMessage={inputParam_SetFireGetMessage}
                                        parentEditMode={(!isNullUndefined(objMessage.visa) && objMessage.visa >= 0 && objMessage.statusId === enum__MessageStatus.ONAPROBATION) ? true : null}
                                    />
                                }
                                <SidePanelNewCommentEvent
                                    bookObject={ inputParam_BookObject }
                                    messageObjectId={ inputParam_MessageObjectId }
                                    messageObjectStatusId={ inputParam_MessageObjectStatusId }
                                    isPanelOpen={ isPanelNewCommentOpen }
                                    setterIsPanelOpen={ setIsPanelNewCommentOpen } 
                                    currentUserName={ inputParam_CurrentUserName }
                                    
                                    setterFireUpdateBoxListControl={ setFireUpdateBoxListMessageEventControl }
                                    userProps={ inputParam_UserProps }

                                    sectionPartyMemberId={ inputParam_UserProps.username !== null && inputParam_MessageObjectId !== null ?

                                        inputParam_UserProps.l_SectionPartyMemberHandler.find(x =>
                                            x.sectionId === inputParam_MessageObjectSectionId) !== undefined
                                        ?
                                        inputParam_UserProps.l_SectionPartyMemberHandler.find(x =>
                                            x.sectionId === inputParam_MessageObjectSectionId).sectionPartyMemberId
                                        : (inputParam_UserProps.isAdmin ? null : "#NA#")
                                        : "#NA#" }
                                />  
                            </Card.Body>
                        }
                    <Card.Footer>
                        <Message message={ message } display={ successful === null? false : showMessage } messageType={ messageType } setterShowMessage={ setShowMessage } />
                        <SendAlertDialog messageType={ messageType } messageContent={ message } setIsDialogOpen={ setIsDialogOpen } isDialogOpen={ isDialogOpen } />
                    </Card.Footer>
                </Card>
            }
            {
                inputParam_EditMode === false &&
                    <>
                            <Row className='p-3'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-section') } labelValue={ objMessage.sectionName } />
                                </Col>

                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-senderparty') } labelValue={ objMessage.sendedPartyName } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} xl={6} title={objMessage.senderUsername}>
                                    <CLabel labelText={ t('data-lang-lbl-sender') } labelValue={ objMessage.senderFullname } />
                                </Col>

                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-creationdate') } labelValue={ moment(objMessage.sendDate).format("DD/MM/YYYY") } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-senddate') } labelValue={ !isNullUndefined(objMessage.sendEventDate) ? moment(objMessage.sendEventDate).format("DD/MM/YYYY") : t('no-data') } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-title') } labelValue={ objMessage.title } />
                                </Col>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-code') } labelValue={ objMessage.messageCode } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xl={12}>
                                    <CTextAreaSimple labelText={t('data-lang-lbl-body')} controlValue={objMessage.body} setterControlValue={null} isInvalirControl={false} editMode={false} />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-answertomessage') } labelValue={ objMessage.answerToMessage ? t('data-lang-lbl-yes') : t('data-lang-lbl-no') } />
                                </Col>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-answerneeded') } labelValue={ objMessage.answerNeeded ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-answerdeadlinedate') } labelValue={ !isNullUndefined(objMessage.answerDeadlineDate) ? moment(objMessage.answerDeadlineDate).format("DD/MM/YYYY") : t('data-lang-lbl-notapply') } />
                                </Col>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-endorse') } labelValue={ objMessage.visa ? t('data-lang-lbl-yes') : t('data-lang-lbl-no')  } />
                                </Col>
                            </Row>
                            <Row className='p-3'>
                                <Col xs={12} xl={6}>
                                    <CLabel labelText={ t('data-lang-lbl-status') } labelValue={ t(objMessage.statusName) } />
                                </Col>
                            </Row>
                        {
                            objMessage.attacheds &&
                            <Row>
                                <h4 className="pt-5">{ t('data-lang-boxname-documents') }</h4>
                                <List
                                    listLocalStoragePageSizeVariableName="messageBoxDocumentsRead"
                                    className="no-compact-list big-header"
                                    manipulateLocalData={ true }
                                    data={ (documentList !== null ? documentList : []) }
                                    setData={ setDocumentList }
                                    columns={ [
                                        {  
                                            key: 'extension',
                                            name: t('data-lang-lbl-type'),
                                            fieldName: 'extension',
                                            minWidth: 40,
                                            maxWidth: 40,
                                            onRender:(item) => {
                                                return getKeyByValue(__DocumentTypeKeys, item.extension)
                                            }
                                        },
                                        {
                                            key: "documentCode",
                                            name: t('data-lang-lbl-code'),
                                            fieldName: "documentCode",
                                            minWidth: 50,
                                            maxWidth: 100,
                                            isResizable: true
                                        },
                                        {
                                            key: "name",
                                            name: t('data-lang-lbl-name'),
                                            fieldName: "name",
                                            minWidth: 100,
                                            maxWidth: 200,
                                            isResizable: true
                                        },
                                        {
                                            key: "modificationUsername",
                                            name: t('data-lang-lbl-modificationusername'),
                                            fieldName: "modificationUsername",
                                            minWidth: 100,
                                            maxWidth: 100,
                                            isResizable: true
                                        },
                                        {
                                            key: "creationUsername",
                                            name: t('data-lang-lbl-creationusername'),
                                            fieldName: "creationUsername",
                                            minWidth: 100,
                                            maxWidth: 100,
                                            isResizable: true
                                        }
                                    ] } />  
                                    <ListPagination
                                        listLocalStoragePageSizeVariableName="messageBoxDocumentsRead" 
                                        data={ (documentList !== null ? documentList : []) }
                                        setData={ setDocumentList } />
                            </Row>
                        }
                    </>
            }
        </>
    );
}

export default MessageBox;